<template>
  <div class="hotel-search">
    <div class="search-item">
      <yj-int-ht-city ref="htCity" :isModalCity="isModalCity" @checkHtCity="checkHtCity" :disabled="disabled"
        :changeRouteRole="htCnQuery.changeRouteRole" @changeRouteRole2="changeRouteRole2">
      </yj-int-ht-city>
    </div>
    <div class="search-item">
      <el-date-picker size="large" v-model="timer" :disabled="disabledDate" :clearable="true" type="daterange"
        range-separator="—" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
        :picker-options="pickerOptions(bookDateRange.minDay, bookDateRange.maxDay)">
      </el-date-picker>
    </div>
    <div class="search-item">
      <yj-int-ht-keyword :cityId="cityId" @checkHtCityGeo="checkHtCityGeo"></yj-int-ht-keyword>
    </div>
    <div class="search-item">
      <RoomAndAdult :rNum="roomNum" :aNum="adultNum" :trip-type="tripType" :cxrLength="chooseCxrList.length"
        @select="selectRoomNumCallback" />
    </div>
    <el-button type="primary" @click="searchHotel" :loading="loading" class="search-btn">搜索</el-button>
    <yj-city-station :ccsqdInfo="htCnCcsqD" :paramsInfo="cityParamsInfo" :visible="dialogVisible"
      :changeRouteRole="htCnQuery.changeRouteRole" @cancel="cancel" @determine="determine"></yj-city-station>
    <!-- <city-dialog :dialogVisible.sync="dialogVisible"/> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ccsqdValidMixin from '@/mixin/models/ccsqdValidMixin.js';
import mixin from '@/mixin';
import RoomAndAdult from './RoomAndAdult.vue';
import { handleIntHotelRoom, handleIntYsRooms } from '../../../hooks/useHotel';

export default {
  mixins: [ccsqdValidMixin, mixin.ccsqdMixin],
  name: 'HotelList',
  props: {
    loading: {
      //父组件传入的lading
      type: Boolean,
      default: () => false,
    },
    bookDateRange: {
      type: Object,
      default() {
        return {};
      },
    },
    newCcsqdSearch: {
      type: Boolean,
      default: false,
    }
  },

  components: {
    RoomAndAdult
  },
  data() {
    return {
      // changeRouteRole==2 
      cityShow: true,
      showCityVisible: false,
      dialogVisible: false,
      departCity: '',
      changeRouteRole: "",
      options: [
        {
          value: '',
          label: '请选择',
        },
        {
          value: 1,
          label: '全部',
        },
        {
          value: 2,
          label: '协议',
        },
      ],
      cityParamsInfo: { //当前城市行息
        cityType: 1,
        cityId: '',
        szm: '',
        proType: 10903,
      },

    }
  },

  computed: {
    ...mapState({
      htCnQuery: (state) => state.intHt.htCnQuery, //
      htCnCcsqD: (state) => state.intHt.htCnCcsqD, //
      htCnParams: (state) => state.intHt.htCnParams,
      cxrList: state => state.intHt.cxrList, // 因公出行人
      ysCxrList: state => state.intHt.ysCxrList, // 因私出行人
      rooms: state => state.intHt.rooms
    }),
    ...mapGetters({
      getVipParamterByParNo: 'common/getVipParamterByParNo',
    }),
    chooseCxrList() {
      if (this.tripType == 2) {
        return this.ysCxrList || [];
      }
      return (this.cxrList || []);
    },
    changeDateRole() {
      return this.htCnQuery.changeDateRole
    },
    // changeRouteRole() {
    // 	// 此处改为调用方法
    // 	return this.$common.getVipParamterByParNo(this.$store,10991,0,'value1',10903) ;
    // },
    changeDateRange() {
      return this.htCnQuery.changeDateRange
    },
    tripType() {
      /* 默认当前因公因私*/
      return this.htCnQuery.tripType
    },
    bookStyle() {
      // 1单订模式  2出差申请单模式
      let bookStyle = this.$common.getBookStyle(this.$store, 10903);
      return bookStyle
    },
    disabled() {
      if (this.newCcsqdSearch) {
        return true
      }
      // 出差申请单模式下，因公模式，changeRouteRole==0的时候禁用

      if (this.tripType == 1 && this.changeRouteRole == 0 && this.bookStyle == 2) {
        return true
      } else {
        return false
      }
    },
    disabledDate() {
      // 出差申请单模式下，因公模式changeDateRole==0的时候禁用，
      if (this.newCcsqdSearch) {
        return true
      }
      if (
        this.tripType == 1 &&
        this.changeDateRole == 0 &&
        this.bookStyle == 2
      ) {
        return true
      } else {
        return false
      }
    },
    departDate() {
      return this.htCnCcsqD?.currentRoute?.departDate //入住日期
    },
    arriveDate() {
      return this.htCnCcsqD?.currentRoute?.arriveDate // 离店日期
    },
    // 控制站点选择
    isModalCity() {
      // 当城市被禁用的时候应该无法触发弹窗！
      // 什么情况下城市选择器无法出来？
      // 因公模式且为出差申请单模式下且changeRouteRole!=1的情况 ，changeRouteRole为2或3的时候才会触发有弹窗的出现！
      let bool = false;
      if (this.tripType == 1 && this.bookStyle == 2 && this.changeRouteRole == 0) {
        bool = false;
      } else if (this.tripType == 1 && this.bookStyle == 2 && this.changeRouteRole == 1) {
        bool = true;
      } else if (this.tripType == 1 && this.bookStyle == 2 && (this.changeRouteRole == 2 || this.changeRouteRole == 3)) {
        bool = false;
        this.$emit("changeRouteRole2")
      } else {
        bool = true;
      }
      return bool
    },
    cityId: {
      get() {
        return this.htCnParams.cityId
      },
      set(val) {
        this.SET_HTCN_PARAMS({ cityId: val })
      },
    },
    timer: {
      get() {
        return [
          this.htCnParams.checkInDate,
          this.htCnParams.checkOutDate,
        ]
      },
      set(val) {
        if (!val) {
          this.SET_HTCN_PARAMS({ checkInDate: '' })
          this.SET_HTCN_PARAMS({ checkOutDate: '' })
        } else {
          this.SET_HTCN_PARAMS({ checkInDate: val[0] })
          this.SET_HTCN_PARAMS({ checkOutDate: val[1] })
        }
      },
    },
    jdType: {
      get() {
        return this.htCnParams.jdType
      },
      set(val) {
        this.SET_HTCN_PARAMS({ jdType: val })
      },
    },
    searchType: {
      get() {
        return this.htCnParams.searchType
      },
      set(val) {
        this.SET_HTCN_PARAMS({ searchType: val })
      },
    },
    keywords: {
      get() {
        return this.htCnParams.keywords
      },
      set(val) {
        this.SET_HTCN_PARAMS({ keywords: val })
      },
    },
    lat: {
      get() {
        return this.htCnParams.lat
      },
      set(val) {
        this.SET_HTCN_PARAMS({ lat: val })
      },
    },
    lon: {
      get() {
        return this.htCnParams.lon
      },
      set(val) {
        this.SET_HTCN_PARAMS({ lon: val })
      },
    },
    roomNum: {
      get() {
        return this.htCnParams.roomNum
      },
      set(val) {
        this.SET_HTCN_PARAMS({ roomNum: val })
      },
    },
    adultNum: {
      get() {
        return this.htCnParams.adultNum
      },
      set(val) {
        this.SET_HTCN_PARAMS({ adultNum: val })
      },
    },
    ccsqdCityName: {
      get() {
        return this.htCnParams.ccsqdCityName
      },
      set(val) {
        this.SET_HTCN_PARAMS({ ccsqdCityName: val })
      },
    },
  },
  watch: {
    htCnCcsqD: {
      handler(newVAL) {
        this.changeRouteRole = this.getChangeRouteRoleForMixin(10903);
        this.SET_HTCN_QUERY({ changeRouteRole: this.changeRouteRole })
      },
      deep: true,
      immediate: false,
    },
  },
  mounted() {
    this.getkgfs()
  },
  methods: {
    ...mapMutations({
      SET_HTCN_PARAMS: 'intHt/SET_HTCN_PARAMS', // 设置查询参数
      SET_HTCN_QUERY: 'intHt/SET_HTCN_QUERY', // 保存因共模式下的自定义信息
      SET_STATE: 'intHt/SET_STATE',
    }),

    getkgfs() {
      this.changeRouteRole = this.getChangeRouteRoleForMixin(10903);
      //这是出差申请单模式的管控规则
      let params10999 = this.$common.getVipParamterByParNo(this.$store, 10999, 0)
      let params10991 = this.changeRouteRole;
      let params10992 = this.$common.getVipParamterByParNo(this.$store, 10992, 0)
      let params10993 = this.$common.getVipParamterByParNo(this.$store, 10993, 0)
      let params10995 = this.$common.getVipParamterByParNo(this.$store, 10995, 0)
      let params10996 = this.$common.getVipParamterByParNo(this.$store, 10996, 0)
      let params20002 = this.$common.getVipParamterByParNo(this.$store, 20002, 0)
      let params20003 = this.$common.getVipParamterByParNo(this.$store, 20003, 0)

      this.SET_HTCN_QUERY({
        gkfsRole: params10999, //0 不管控  1出差申请单管控  2差旅标准管控
        changeRouteRole: params10991, //根据出差申请单预订时可更改行程
        changeDateRole: params10992, //"查询出差申请单预订行程日期可否变更
        changeDateRange: params10993, //根据出差申请单预订时可更改出行日期
        params10995, //  "成本中心是否必填"
        params10996, //   "项目是否必填"
        params20002, //   "订单填写页面是否显示成本中心，1显示，0不显示"
        params20003, //   "订单填写页面是否显示项目，1显示，0不显示"
      })
    },
    pickerOptions(minDay, maxDay) {
      return {
        //定义不可选择时间 暂无预约功能 查找有效日期
        // 查询出差申请单预订行程日期可否变更 0不可更改  1 按行程更改 2 出差申请单日期范围更改
        disabledDate(time) {
          let minTime = new Date(new Date(minDay).toLocaleDateString()).getTime();
          let maxTime = new Date(new Date(maxDay).toLocaleDateString()).getTime();
          return time.getTime() < minTime || time.getTime() > maxTime;
        },
      }
    },
    checkHtCity(val) {
      this.cityId = val.cityId
      this.ccsqdCityName = val.cityName
      this.$emit('getHtClbz', val) //传递最新的CiTY id更新列表
    },
    checkHtCityGeo(val) {
      // this.searchType = val.type || val.poiType || ''
      this.keywords = val.nameCn;
      // this.lat = val.lat
      // this.lon = val.lng
    },
    changeRouteRole2() {
      // 触发弹窗之前先判断是否有出差申请单ID 如果没有弹出警告！
      if (this.tripType == 1 && JSON.stringify(this.htCnCcsqD) != '{}') {
        this.cityParamsInfo = {
          cityType: 1,
          cityId: this.htCnParams.cityId,
          szm: '',
          proType: 10903,
        }
        this.dialogVisible = true;

        // this.showCityVisible=true
      } else {
        this.$message({
          type: 'error',
          message: '因公模式下请先选择你的出差申请单',
        })
      }


    },
    goDetail(num) {
      this.$emit('toHtDetail', num)
    },

    searchHotel() {

      // 地点日期必填！
      // 因共出差申请单的情况下，出差申请单必填，先判断因共因私			
      // 新增出差申请单时触发
      if (this.newCcsqdSearch) {
        this.$emit('searchHotel')
        return
      }
      if (!this.cityId || !this.htCnParams.ccsqdCityName) {
        this.$message({
          type: 'error',
          message: '请先输入城市！',
        })
      } else if (this.timer.length < 1) {
        this.$message({
          type: 'error',
          message: '请输入你的时间',
        })

      } else if (this.$dateTime.getDiffDay3(this.htCnParams.checkInDate, this.$dateTime.getToDay(),) < 0) {
        this.$message({
          type: 'error',
          message: '查询时间不允许小于当前时间',
        })
      } else {
        if (this.tripType == 1 && this.bookStyle == 2 && !this.htCnCcsqD.ccsqdId) {
          this.$message({
            type: 'error',
            message: '因公模式下请先选择你的出差申请单',
          })
        } else {

          // 校验房间数量，每间房必须相同人数
          if (this.rooms && this.rooms.length > 0 && this.tripType == 1) {
            const firstValidCount = this.htCnParams.adultNum || 1;
            const mismatchedRooms = this.rooms.filter(rc => rc.length !== firstValidCount);
            if (mismatchedRooms.length !== 0) {
              this.$confirm('国际酒店下单必须保证每个房间人数相同，如需房间不同人数请分开下单！', '温馨提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
              })
              return;
            }
          }

          let vaildParamNoFor20103 = this.$common.getVipParamterByParNo(this.$store, '20103', 0, 'value1');
          if (this.tripType == 1 && this.bookStyle == 2 && vaildParamNoFor20103 == 1) {
            let queryObj = {
              "ccsqdId": this.htCnCcsqD.ccsqdId,
              "empIdList": this.cxrList.map(cxrItem => cxrItem.empId),
              "endCity": this.cityId,
              "endDate": this.htCnParams.checkOutDate,
              "productType": "10903",
              "startCity": this.cityId,
              "startDate": this.htCnParams.checkInDate,
            };
            this.vaildCcsqdFor20103(queryObj, () => {
              this.$emit('searchHotel')
            }, () => {

            })
          } else {
            this.$emit('searchHotel')
          }
        }
      }
    },
    cancel(bool) {
      this.dialogVisible = bool;
    },
    determine(info) {
      var obj = {};
      obj = {
        ccsqdCityName: info.cityName, //  出发城市
        cityId: info.cityId,// 出发城市ID
        checkInDate: '', //日期开始时间
        checkOutDate: '', // 日期结束时间
      }
      this.SET_HTCN_PARAMS(obj);
      this.dialogVisible = false;
    },
    // 选择房间数 成人数 儿童数回调
    selectRoomNumCallback(item) {
      if (this.tripType == 1) {
        // 分配房间
        let adNum = item.adultNum;
        let num = item.roomNum;
        // 人数总量大于房间数*单个房间人数
        if (adNum * num < this.chooseCxrList.length) {
          num = Math.ceil(this.chooseCxrList.length / adNum);
        }
        let hotelRoom = handleIntHotelRoom({ preCxrList: this.chooseCxrList, maxFjs: num, maxNums: adNum });
        let stateObj = {
          allRank: hotelRoom.allRank,
          rooms: hotelRoom.rooms,
        }
        if (this.tripType == 1) {
          stateObj.cxrList = hotelRoom.cxrList;
        } else {
          stateObj.ysCxrList = hotelRoom.cxrList;
        }
        this.SET_STATE(stateObj)
        this.roomNum = hotelRoom.roomNum;
        if (hotelRoom.rooms && hotelRoom.rooms.length > 0) {
          adNum = hotelRoom.rooms[0].length ?? adNum;
        }
        this.adultNum = adNum;
        let empObj = {
          empRank: hotelRoom.minEmpRank, //   职级
          useNameclbz: hotelRoom.minEmpName, // 本次预订使用谁的差旅标准
        }
        this.SET_HTCN_QUERY(empObj)
        this.$emit('getHtClbz')
        // handleCxrRooms(currentCxr.value, false)
        // showRoomPop.value = false;
      } else {
        this.roomNum = item.roomNum;
        this.adultNum = item.adultNum;
        let cRooms = handleIntYsRooms(item.roomNum, item.adultNum, this.rooms);
        console.log('cRooms === ', cRooms);
        this.SET_STATE({
          rooms: cRooms
        })
      }
    }
  },
}
</script>

<style scoped lang="scss">
$bcolor: #006bb9;

/deep/ .el-input__prefix {
  color: #006bb9;
  text-align: center;
  width: 25px;
}

.hotel-search {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 18px 0;

  .search-item {
    margin-right: 20px;

    .ht-city {
      position: relative;

      .ht-city-modal {
        position: absolute;
        top: 40px;
        left: 0;
      }
    }

    /deep/ .el-input__inner {
      height: 45px;
      border: 2px solid #d9e1ed;
      border-radius: 0px;
    }

    .city-ht {
      height: 500px;
      overflow: auto;
    }
  }

  .search-btn {
    width: 100px;
    height: 45px;
    color: #fff;
    cursor: pointer;
    border-radius: 0;
    font-size: 14px;
  }

  /deep/ .el-date-editor .el-range-separator {
    padding: 0 5px;
    line-height: 32px;
    width: 10%;
    color: #303133;
  }
}
</style>
